import { RefObject } from 'react';

interface UseAnimationWiggleReturn {
  triggerWiggle: () => void;
}

/**
 * Custom hook that provides a triggered, one-time, horizontal shake
 * animation that mimics a head-shaking ‘no’ gesture.
 *
 * This animation is meant to be used as a visual feedback mechanism for
 * user actions as a gentle error indicator.
 */
const useAnimationWiggle = (elementRef: RefObject<HTMLElement>): UseAnimationWiggleReturn => {
  // Wiggle the element back-and-forth. Each cycle reduces the wiggle
  // distance following the golden ratio.
  const triggerWiggle = (): void => {
    if (elementRef.current) {
      elementRef.current.animate(
        [
          { transform: 'translateX(0)' },
          { transform: 'translateX(-12px)' },
          { transform: 'translateX(12px)' },
          { transform: 'translateX(-7px)' },
          { transform: 'translateX(7px)' },
          { transform: 'translateX(-5px)' },
          { transform: 'translateX(5px)' },
          { transform: 'translateX(-3px)' },
          { transform: 'translateX(3px)' },
          { transform: 'translateX(-2px)' },
          { transform: 'translateX(0)' },
        ],
        {
          // Matches Vital token var(--vds-duration-lg)
          duration: 600,
          // Matches Vital token var(--vds-timing-ease-in-out)
          easing: 'cubic-bezier(.58,0,.42,1)',
        },
      );
    }
  };

  return { triggerWiggle };
};

export default useAnimationWiggle;
